<div
  class="settings"
  [class.settings--visible]="isOpen"
  role="dialog"
  aria-modal="true"
  aria-labelledby="cookie-settings-title"
>
  <div class="settings__content">
    <div class="settings__content-inner">
      <div class="settings__header">
        <h2 class="settings__title" id="cookie-settings-title">
          Cookie Settings
        </h2>
        <button
          class="settings__close"
          (click)="closeDialog()"
          aria-label="Close cookie settings"
        ></button>
      </div>
      <p class="settings__description">
        When you visit any website, it may store or retrieve information on your
        browser in the form of cookies. This information may be about you, your
        preferences or your device. This is mostly used to make the website work
        as you would expect it to. The information doesn’t identify you but can
        be used to offer a more personalized web experience.
        <br /><br />
        Because we respect your right to privacy, you can choose to not allow
        certain types of cookies. By clicking on the different category
        headings, you can find out more and change from our default settings.
        However, by blocking certain types of cookies this may negatively impact
        your experience on the site and the services we are able to offer.
      </p>
      <div class="preferences">
        <h3 class="preferences__title">Manage Consent Preferences</h3>
        <div class="accordion">
          @for (item of accordionItems; track $index) {
          <div class="accordion__item">
            <div class="accordion__header-wrapper">
              <button
                class="accordion__button"
                [attr.aria-expanded]="item.isExpanded"
                [attr.aria-controls]="item.id"
                (click)="toggleAccordion(item)"
              >
                <span class="accordion__icon" aria-hidden="true"></span>
                <span class="accordion__title">{{ item.title }}</span>
              </button>
              <label class="switch" (click)="$event.stopPropagation()">
                <input
                  class="switch__input"
                  type="checkbox"
                  [checked]="item.isEnabled"
                  [disabled]="item.isRequired"
                  [attr.aria-label]="
                    item.isRequired
                      ? item.title + ' always enabled'
                      : 'Enable ' + item.title
                  "
                  (change)="toggleSwitch(item)"
                />
                <span class="switch__slider"></span>
              </label>
            </div>
            <div
              class="accordion__panel"
              [id]="item.id"
              [class.accordion__panel--expanded]="item.isExpanded"
            >
              <div class="accordion__content">
                {{ item.content }}
              </div>
            </div>
          </div>
          }
        </div>
      </div>
      <button class="btn btn--primary" (click)="saveCookiePreferences()">
        CONFIRM MY CHOICES
      </button>
    </div>
  </div>
</div>
